var _path, _polygon, _polygon2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 29 21",
    style: {
      enableBackground: "new 0 0 29 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,0.6c1.1,0,2,0.9,2,2v15.7c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2.6c0-1.1,0.9-2,2-2H27z  M27,18.4V2.6H2v15.7H27z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28.1,7.5 28.1,9.5 0.9,9.5 0.9,7.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.1,4.6 28.1,6.6 0.9,6.6 0.9,4.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5,11.5c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0H4.8c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0H13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,14.4c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0H4.8c-0.6,0-1-0.4-1-1 c0-0.5,0.4-0.9,0.9-1l0.1,0H7.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.3bd9d33eefe2d047544aa0389c3c312e.svg";
export { ForwardRef as ReactComponent };